import axios from "axios";

class Credentials {
	application;

	api;

	bi;
  
  async fetchCredentials() {
		console.log("Fetching credentials");
    const { data } = await axios.get( `${process.env.PUBLIC_URL}/kiq_web_deploy.json` );

		this.application = data.application;
		this.api = data.api;
		this.bi = data[ 'business-intelligence' ];

		localStorage.setItem( `${ data.application }-credentials`, JSON.stringify( {
			api: data.api,
			bi: data[ 'business-intelligence' ]
		} ) );
  }
}

const credentials = new Credentials()

const api = axios.create();

api.interceptors.request.use( async ( config ) => {
	console.log('intercepting request')
	if ( !credentials.application ) {
		await credentials.fetchCredentials();
	}

	config.baseURL = credentials.api.uri;
	config.headers = {
		...config.headers,
		api_key: credentials.api.key
	};

	return config;
},
( err => {
	console.error(err);
}) );

export { api, credentials };